import React from "react";
import { Skeleton } from "@mui/material";

const DSSkeleton = (props: React.ComponentProps<typeof Skeleton>) => {
  return <Skeleton {...props} />;
};

export default DSSkeleton;
